import { createStore, applyMiddleware } from "redux";
import rootReducers from "./../reducers";
import thunk from "redux-thunk";
import { createBrowserHistory, History } from "history";

const history = createBrowserHistory();
const store = createStore(rootReducers(history), applyMiddleware(thunk));

export default store;
